module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', [_c('ul', {
    staticClass: "user-info"
  }, [_c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("医院")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.hospitalName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("科室")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.deptName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("医生")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.doctName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("卡号")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v("居民健康卡" + _vm._s(_vm._f("dotted")(_vm.cardNo)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("门诊号")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.visitId))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("开单时间")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.makeTime))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("门诊诊断")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.diagnosis))])])]), _vm._v(" "), _c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-top": "0.5rem"
    }
  }, [_c('ul', {
    staticClass: "tab-top"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.selectedTab.tabId == item.tabId
      },
      attrs: {
        "id": 'register-departDoctor-tab-' + item.tabId
      },
      on: {
        "click": function($event) {
          return _vm.onSelectedTab(index)
        }
      }
    }, [_c('span', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(item.tabName))])])
  }), 0)]), _vm._v(" "), _vm._l((_vm.medicalInfo), function(item, index) {
    return (item.recipeType == _vm.selectedTab.tabId) ? _c('div', [_c('ul', {
      staticClass: "recipe-list"
    }, [_c('li', [(_vm.selectedTab.tabId == '3') ? _c('span', {
      staticClass: "left",
      staticStyle: {
        "color": "#54a9ec"
      }
    }, [_vm._v("处方号:  " + _vm._s(item.recipeId))]) : _vm._e(), _vm._v(" "), (_vm.selectedTab.tabId !== '3') ? _c('span', {
      staticClass: "left",
      staticStyle: {
        "color": "#54a9ec"
      }
    }, [_vm._v(_vm._s(item.recipeName))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "right",
      staticStyle: {
        "color": "#fe0202"
      }
    }, [_vm._v(_vm._s(_vm._f("formatFee")(item.recipeFee)))])]), _vm._v(" "), _vm._l((item.items), function(project, index) {
      return (_vm.selectedTab.tabId == '3') ? _c('ul', {
        staticClass: "project-list",
        staticStyle: {
          "font-size": "13px"
        }
      }, [_c('li', [_c('span', [_vm._v(_vm._s(project.itemName) + " \n              "), (project.specs != '') ? _c('span', {
        staticClass: "project-title"
      }, [_vm._v("(" + _vm._s(project.specs) + ")")]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('div', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("单价:  ")]), _vm._v(_vm._s(_vm._f("formatFee")(project.price, false)))])]), _vm._v(" "), _c('div', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("数量:  ")]), _vm._v(_vm._s(project.qty) + _vm._s(project.unit))])])]), _vm._v(" "), _c('li', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("使用方法：  ")]), _vm._v(_vm._s(project.instructions))])]), _vm._v(" "), _c('li', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("厂商：  ")]), _vm._v(_vm._s(project.factory))])])]) : _vm._e()
    }), _vm._v(" "), (_vm.selectedTab.tabId == '3') ? _c('ul', {
      staticClass: "project-list",
      staticStyle: {
        "font-size": "13px"
      }
    }, [_c('li', [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("医生 (审核、核对、发药)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.checkDoctor))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("药师/士 (调配)")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.execDoctor))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "color-gray"
    }, [_vm._v("取药窗口")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.location))])])]) : _vm._e(), _vm._v(" "), _vm._l((item.items), function(project, index) {
      return (_vm.selectedTab.tabId !== '3') ? _c('ul', {
        staticClass: "project-list",
        staticStyle: {
          "font-size": "13px"
        }
      }, [_c('li', [_c('span', [_vm._v(_vm._s(project.itemName) + " \n              "), (project.specs != '') ? _c('span', {
        staticClass: "project-title"
      }, [_vm._v("(" + _vm._s(project.specs) + ")")]) : _vm._e()])]), _vm._v(" "), _c('li', [_c('div', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("单价:  ")]), _vm._v(_vm._s(_vm._f("formatFee")(project.price, false)))])]), _vm._v(" "), _c('div', [_c('span', [_c('span', {
        staticClass: "color-gray"
      }, [_vm._v("数量:  ")]), _vm._v(_vm._s(project.qty) + _vm._s(project.unit))])])])]) : _vm._e()
    })], 2)]) : _vm._e()
  }), _vm._v(" "), _c('no-record', {
    attrs: {
      "id": "myregister-norecord",
      "condition": _vm._f("dataFilter")(_vm.medicalInfo, _vm.selectedTab.tabId),
      "tips": "抱歉，没有处方记录"
    }
  }), _vm._v(" "), (
    _vm.selectedTab.tabId == '3' &&
    _vm.dataFilter(_vm.medicalInfo, _vm.selectedTab.tabId).length != 0
  ) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('span', {
    staticClass: "color-blue"
  }, [_vm._v("提示信息:")])]), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("按卫生部、国家中医药管理局卫医发[2002]24号文件规定:为保证患者用药安全，药品已经发出，不得退换。")])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b344f6cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/elcPrescription/PrescriptionDetail.vue
// module id = 869
// module chunks = 0